const BROKERS = {
  infobip: { label: 'Infobip', logo: '/img/icons/logos/infobip-logo.svg' },
  pointer: { label: 'Pointer', logo: '/img/icons/logos/pointer-logo.svg' },
  otima: { label: 'Ótima', logo: '/img/icons/logos/otima-logo.svg' },
  sendgrid_negotiation: { label: 'Twilio', logo: '/img/icons/logos/twilio-logo.svg' },
  pgmais: { label: 'PG Mais', logo: '/img/icons/logos/pgmais-logo.svg' }
}

export function getBrokerLogoPath (owner) {
  if (!owner || !BROKERS[owner]) return ''
  return BROKERS[owner].logo
}

export function getBrokerLabel (owner) {
  if (!owner) return ''
  if (BROKERS[owner]) return BROKERS[owner].label
  return owner.charAt(0).toUpperCase() + owner.slice(1)
}
